import Pipe1 from "../../assets/images/products/pipe-01.jpg";
import Pipe2 from "../../assets/images/products/pro-01.jpg";
import Pipe3 from "../../assets/images/products/pipe-03.jpg";
import Pipe4 from "../../assets/images/products/pro-02.jpg";
import Pipe5 from "../../assets/images/products/pipe-05.jpg";
import Pipe6 from "../../assets/images/products/pipe-06.jpg";
import Pipe7 from "../../assets/images/products/pro-03.jpg";
import Pipe8 from "../../assets/images/products/pro-04.jpg";
import Pipe9 from "../../assets/images/products/pro-05.jpg";
import Pipe10 from "../../assets/images/products/pro-06.jpg";
import Pipe11 from "../../assets/images/products/pro-07.jpg";
import Pipe12 from "../../assets/images/products/pro-08.jpg";
import Pipe13 from "../../assets/images/products/pro-09.jpg";
import Pipe14 from "../../assets/images/products/pro-10.jpg";
import Pipe15 from "../../assets/images/products/pro-11.jpg";
import Pipe16 from "../../assets/images/products/pro-12.jpg";
import Pipe17 from "../../assets/images/products/pro-13.jpg";
import Pipe18 from "../../assets/images/products/pro-14.jpg";
import Pipe19 from "../../assets/images/products/pipe-19.jpg";
import Pipe20 from "../../assets/images/products/pipe-20.jpg";
import Pipe21 from "../../assets/images/products/pipe-21.jpg";
import Pipe22 from "../../assets/images/products/pipe-22.jpg";
import Pipe23 from "../../assets/images/products/pipe-23.jpg";
import Pipe24 from "../../assets/images/products/pipe-24.jpg";

const products = [
  {
    title: "RCC Hume Pipe",
    img: Pipe1,
    price: "₹1800/Pipe",
    size: "600mm",
    rating: "4.9",
    stock: "Available",
    material: "M30 Concrete",
    strength: "Heavy Load",
    uses: "Drainage, culvert, water flow",
    description: "High strength RCC pipe for underground drainage.",
  },
  {
    title: "RCC NP3 Pipe",
    img: Pipe2,
    price: "₹2500/Pipe",
    size: "900mm",
    rating: "4.8",
    stock: "Available",
    material: "Reinforced Concrete",
    strength: "NP3 Grade",
    uses: "Road crossing projects",
    description: "Strong reinforced pipe for civil construction.",
  },
  {
    title: "RCC NP4 Pipe",
    img: Pipe3,
    price: "₹4200/Pipe",
    size: "1200mm",
    rating: "5.0",
    stock: "Premium",
    material: "High Grade RCC",
    strength: "NP4 Heavy Duty",
    uses: "Industrial drainage",
    description: "Designed for high pressure applications.",
  },
  {
    title: "RCC Jacking Pipe",
    img: Pipe4,
    price: "₹6500/Pipe",
    size: "1500mm",
    rating: "4.9",
    stock: "Available",
    material: "Steel Reinforced",
    strength: "Extra Strong",
    uses: "Underground tunneling",
    description: "Used for trenchless pipeline installation.",
  },
  {
    title: "RCC Collar Pipe",
    img: Pipe5,
    price: "₹2200/Pipe",
    size: "800mm",
    rating: "4.7",
    stock: "Available",
    material: "Concrete",
    strength: "Medium Duty",
    uses: "Storm water drainage",
    description: "Perfect fitting RCC collar joint pipe.",
  },
  {
    title: "RCC Drain Pipe",
    img: Pipe6,
    price: "₹3000/Pipe",
    size: "1000mm",
    rating: "4.8",
    stock: "Available",
    material: "RCC",
    strength: "Heavy Duty",
    uses: "Municipal drainage",
    description: "Long life concrete drainage pipe.",
  },
  {
    title: "RCC Irrigation Pipe",
    img: Pipe7,
    price: "₹2800/Pipe",
    size: "750mm",
    rating: "4.6",
    stock: "Available",
    material: "Concrete Mix",
    strength: "Strong",
    uses: "Agriculture water supply",
    description: "Reliable pipe for irrigation systems.",
  },
  {
    title: "RCC Industrial Pipe",
    img: Pipe8,
    price: "₹5200/Pipe",
    size: "1800mm",
    rating: "5.0",
    stock: "Premium",
    material: "Heavy RCC",
    strength: "Maximum Load",
    uses: "Factories and industries",
    description: "Built for industrial drainage solutions.",
  },
  {
    title: "RCC NP2 Pipe",
    img: Pipe9,
    price: "₹1400/Pipe",
    size: "450mm",
    rating: "4.5",
    stock: "Available",
    material: "Light Reinforcement",
    strength: "NP2 Grade",
    uses: "Low traffic drainage",
    description: "Ideal for domestic sewage and village roads.",
  },
  {
    title: "RCC Half Round Pipe",
    img: Pipe10,
    price: "₹950/Pipe",
    size: "300mm",
    rating: "4.4",
    stock: "Available",
    material: "M25 Concrete",
    strength: "Light Duty",
    uses: "Open rainwater drains",
    description: "Semicircular open channel pipe for surface runoff.",
  },
  {
    title: "Precast Concrete Manhole",
    img: Pipe11,
    price: "₹7500/Item",
    size: "1200mm ID",
    rating: "4.9",
    stock: "Premium",
    material: "M35 Concrete",
    strength: "Extra Heavy Duty",
    uses: "Sewerage main lines",
    description: "Precast inspection chambers for urban sewer networks.",
  },
  {
    title: "RCC Well Ring",
    img: Pipe12,
    price: "₹1600/Ring",
    size: "915mm",
    rating: "4.7",
    stock: "Available",
    material: "Reinforced Cement",
    strength: "High Tensile",
    uses: "Water wells & soak pits",
    description: "Durable structural rings for open water wells.",
  },
  {
    title: "RCC Perforated Pipe",
    img: Pipe13,
    price: "₹2100/Pipe",
    size: "600mm",
    rating: "4.6",
    stock: "Out of Stock",
    material: "Porous Concrete",
    strength: "Medium Load",
    uses: "Sub-surface drainage",
    description: "Perforated design for groundwater table management.",
  },
  {
    title: "RCC Square Culvert",
    img: Pipe14,
    price: "₹9800/Block",
    size: "1500x1500mm",
    rating: "5.0",
    stock: "Premium",
    material: "M40 Concrete",
    strength: "Extreme Class",
    uses: "Highway cross drainage",
    description: "Heavy duty precast box culverts for heavy vehicles.",
  },
  {
    title: "RCC Spigot Pipe",
    img: Pipe15,
    price: "₹3400/Pipe",
    size: "1100mm",
    rating: "4.8",
    stock: "Available",
    material: "Socket Reinforced",
    strength: "Leak-Proof Joint",
    uses: "Gravity water mains",
    description: "Features custom socket end for flexible rubber rings.",
  },
  {
    title: "Precast Drain Cover",
    img: Pipe16,
    price: "₹1200/Slab",
    size: "600x900mm",
    rating: "4.7",
    stock: "Available",
    material: "M30 Steel Fiber",
    strength: "Anti-Cracking",
    uses: "Footpath drain covering",
    description: "Heavy-duty covers with pre-molded lifting hooks.",
  },
  {
    title: "Precast U-Drains",
    img: Pipe17,
    price: "₹3100/Item",
    size: "500x500mm",
    rating: "4.8",
    stock: "Available",
    material: "Vibrated Concrete",
    strength: "High Flow Duty",
    uses: "Storm water channels",
    description: "U-shaped structural components for fast open drainage.",
  },
  {
    title: "Precast Septic Tank",
    img: Pipe18,
    price: "₹14500/Unit",
    size: "3000 Liters",
    rating: "4.9",
    stock: "Premium",
    material: "M35 Reinforced",
    strength: "Sulphate Resistant",
    uses: "Waste treatment",
    description: "Multi-chamber precast septic system ready to install.",
  },
  {
    title: "RCC Road Barrier",
    img: Pipe19,
    price: "₹4800/Block",
    size: "2000mm Length",
    rating: "5.0",
    stock: "Available",
    material: "High-Mass M40",
    strength: "Crash Resistant",
    uses: "Highway lane division",
    description: "Standard Jersey barrier design for enhanced road safety.",
  },
  {
    title: "RCC Fencing Poles",
    img: Pipe20,
    price: "₹350/Pole",
    size: "7 Feet",
    rating: "4.5",
    stock: "Available",
    material: "Pre-stressed RCC",
    strength: "Weatherproof",
    uses: "Boundary protection",
    description: "Reinforced poles with built-in holes for barbed wire.",
  },
  {
    title: "RCC Cable Trench",
    img: Pipe21,
    price: "₹2600/Meter",
    size: "400x400mm",
    rating: "4.6",
    stock: "Available",
    material: "M30 RCC",
    strength: "Flame Retardant",
    uses: "Substation cabling",
    description: "Protective ground trenches designed for high voltage wires.",
  },
  {
    title: "Precast Compound Wall",
    img: Pipe22,
    price: "₹110/Sq.Ft",
    size: "Custom Height",
    rating: "4.9",
    stock: "Available",
    material: "High Strength Mix",
    strength: "Wind Resistant",
    uses: "Property boundary",
    description: "Fast-erecting interlocking panels and column posts.",
  },
  {
    title: "RCC Slotted Pipes",
    img: Pipe23,
    price: "₹2300/Pipe",
    size: "450mm",
    rating: "4.4",
    stock: "Out of Stock",
    material: "Concrete Type-2",
    strength: "Standard Duty",
    uses: "Rainwater harvesting",
    description: "Heavy concrete pipes customized with water filtration slots.",
  },
  {
    title: "RCC Earth Pit Chamber",
    img: Pipe24,
    price: "₹850/Box",
    size: "300x300mm",
    rating: "4.7",
    stock: "Available",
    material: "Cast Concrete",
    strength: "Impact Protective",
    uses: "Electrical earthing",
    description: "Compact enclosure with a heavy top lid for testing pits.",
  },
];

export default products;
